export enum EModeValue {
  MINIMIZE,
  DOCK,
  HIDE,
}
